import CommunicationScreen from './CommunicationScreen.js';

export default CommunicationScreen;
